import {LogoutOutlined, SettingOutlined, UserOutlined} from "@ant-design/icons";
import {Dropdown, Menu, Spin} from "antd";
import React from "react";
import {useAuthorization} from "../../../../features/auth/api/useAuthorization";
// import {selectAuthActions} from "../../../../redux/auth/selectors";
import s from "./usermenu.module.css";

const UserMenu = () => {
  const {loading, signOut} = useAuthorization();

  const menu = (
    <Menu>
      <Menu.Item key="0" icon={<SettingOutlined />} disabled>
        Настройки
      </Menu.Item>
      <Menu.Item
        key="1"
        onClick={signOut}
        icon={loading.signOut ? <Spin size="small" /> : <LogoutOutlined />}
      >
        Выйти
      </Menu.Item>
    </Menu>
  );

  return (
    <div
      style={{
        display: "flex",
        flexFlow: "column",
        justifyContent: "center",
        cursor: "pointer"
      }}
    >
      <Dropdown overlay={menu} trigger={["click"]}>
        <div className={s.wrapper}>
          <UserOutlined style={{fontSize: "1.75rem", color: "#001529"}} />
        </div>
      </Dropdown>
    </div>
  );
};

export default UserMenu;
